import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/tokens.css';
import './plugins/base'
import VeeValidate from 'vee-validate';
import Vuex from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import moment from 'moment';
import VueExcelXlsx from "vue-excel-xlsx";
import VueApexCharts from 'vue-apexcharts'
import DatetimePicker from 'vuetify-datetime-picker';
import axios from 'axios';
export const axiosInstance = axios.create({});
import CKEditor from 'ckeditor4-vue'

axiosInstance.interceptors.response.use(
    response => {
      return Promise.resolve(response);
    },
    error => {
      const status = error.response.status;
      if(status === 401) { //not authenticated
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
      else if(status === 405) {  //not allowed
        window.location.href = '/notAllowed';
      }
      else {
          return Promise.reject(error);
      }
    }
);

Vue.use(VueApexCharts)
Vue.use(CKEditor)

Vue.component('apexchart', VueApexCharts)

import {
  faHome,
  faUser,
  faUserPlus,
  faSignInAlt,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';

import vuetify from './plugins/vuetify';
import i18n from './i18n'

library.add(faHome, faUser, faUserPlus, faSignInAlt, faSignOutAlt);

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

Vue.use(VeeValidate, {
  fieldsBagName: 'vvFields'
});
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuex);
Vue.use(VueExcelXlsx);
Vue.use(DatetimePicker);

export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app');
